<template>
  <a
    :href
    :target
    :rel
  >
    <slot />
  </a>
</template>

<script setup lang="ts">
import type { NuxtLinkProps } from 'nuxt/app';
import { useServiceEndpoints } from '../../../composables/useServiceEndpoints';

// TODO: has to be resolved the same way as NuxtLink
const props = defineProps<NuxtLinkProps>();
const { mapDomain } = useServiceEndpoints();

const orginalHref = (props.href as string) || (props.to as string);
const href = ref(orginalHref);

// using this pattern to avoid race condiation resulting in hydration mismatch,
// need to show the original href on first render then update it once service
// endpoints are ready
onMounted(async () => {
  if (!orginalHref) {
    console.warn('No href provided to PTCLink', JSON.stringify(props));
    return;
  }

  if (orginalHref.includes('.sanity.io/')) {
    console.warn('Sanity file URL detected:', orginalHref);
    return;
  }

  href.value = await mapDomain(orginalHref);
});

const target = props.target || undefined;
const rel = props.rel ?? (target === '_blank' ? 'noopener noreferrer' : undefined);
</script>
